import { FETCH_FEATURES_API, generateBFFUrl, PROFILE_DATA_API } from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';

export type FeaturesType = {
  [key: string]: boolean;
};

export const fetchFeatures = async (serverCookie?: any): Promise<FeaturesType> => {
  const features = await axiosInstance
    .get(generateBFFUrl(FETCH_FEATURES_API), {
      headers: generateHttpHeaders(serverCookie),
    })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return features;
};
